<template>
  <div class="content">
    <ModalSaldo
      :showModal="showModalSaldo"
      :command="command"
      @btnSim="editarSaldo"
      @btnNao="showModalSaldo = false"
      required
    />

    <BlockUI
      v-if="blockScreen"
      :message="blockScreenData.msg"
      :url="blockScreenData.url"
    />

    <HeaderPage
      pageTitle="Lista de Carteira"
      pageSubTitle="Gerencie a carteira dos usuários"
    />

    <v-row justify="end">
      <v-col cols="auto">
        <v-btn
          small
          rounded
          elevation="0"
          outlined
          color="green"
          @click="modalNewWallet = true"
        >
          <span class="pr-1">NOVA CARTEIRA</span>
          <v-icon small class="green--text">mdi-wallet </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-card class="box pa-7 mt-4" rounded="lg">
      <h5>Pesquisar</h5>

      <v-card-subtitle>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md4 sm6>
              <v-col align="start">
                <v-text-field
                  v-model="search"
                  prepend-icon="search"
                  label="Procurar"
                  single-line
                  hide-details
                />
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>
    </v-card>

    <v-card class="pa-2 mt-10" rounded="lg">
      <v-data-table
        :headers="headers"
        :items="walletData"
        :search="search"
        class="mt-2"
        no-data-text="Nenhuma carteira registrada"
        :footer-props="{
          'items-per-page-text': 'Linhas por página:',
        }"
      >
        <template v-slot:[`item.money`]="{ item }">
          <td>R$ {{ item.money | formatPrice }}</td>
        </template>
        <template v-slot:[`item.user.name`]="{ item }">
          <td>{{ item.user.name | formatName }}</td>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <ActionButton
            color="info"
            icon="assignment"
            message="Detalhes de uso"
            @onclick="detalhesWallet(item)"
          />
          <ActionButton
            icon="add"
            color="success"
            message="Adicionar Saldo"
            @onclick="abrirModalSaldo('Adicionar', item.id)"
          />

          <ActionButton
            icon="remove"
            color="error"
            message="Retirar Saldo"
            @onclick="abrirModalSaldo('Retirar', item.id)"
          />
        </template>
      </v-data-table>
    </v-card>

    <v-layout row>
      <v-dialog ps-2 v-model="modalNewWallet" persistent max-width="400">
        <v-card class="pa-5 pb-3">
          <v-flex mx-auto>
            <v-autocomplete
              filled
              chips
              label="Clients"
              v-model="Vclient"
              :items="clientItems"
              color="blue darken-4"
              hide-no-data
              item-text="name"
              item-value="id"
              placeholder="Selecione os clientes"
              return-object
              multiple
              required
              @change="searchUsersFromClient()"
            ></v-autocomplete>
          </v-flex>

          <v-flex mx-auto>
            <v-autocomplete
              :disabled="notsingleClient"
              :items="users"
              v-model="selectedUsers"
              :loading="isLoadingUser"
              color="blue darken-4"
              hide-no-data
              hide-selected
              item-text="name"
              item-value="id"
              label="Usuário"
              placeholder="Digite o nome para buscar o usuário"
              return-object
              multiple
              required
            ></v-autocomplete>
          </v-flex>

          <v-flex md8>
            <label for="model">Saldo a adicionar:</label>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span
                  class="input-group-text font-weight-medium"
                  id="basic-addon1"
                >
                  R$
                </span>
              </div>
              <money v-model="saldoAdicionar" class="form-control"> </money>
            </div>
          </v-flex>

          <v-flex>
            <v-textarea
              outlined
              label="Motivo do Saldo"
              v-model="saldoDescription"
            >
            </v-textarea>
          </v-flex>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="modalNewWallet = false">Cancelar</v-btn>
            <v-btn color="blue darken-1" @click="cadastrarSaldo()"
              >Salvar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import NumberHelper from './../../helpers/NumberHelper';
import ActionButton from '../shared/ActionButtonsTemplate';

import ModalSaldo from '../shared/ModalSaldo.vue';
import Breadcrumb from '../shared/Breadcrumb.vue';
import HeaderPage from '../public/HeaderPage.vue';

import WalletController from '../../controllers/WalletController';
import ClientController from '../../controllers/ClientController.js';
import UserController from '../../controllers/UserController.js';

export default {
  created() {
    this.report();
    this.searchClients();
  },
  components: {
    ActionButton,
    Breadcrumb,
    ModalSaldo,
    HeaderPage,
  },
  data() {
    return {
      walletController: new WalletController(this.$resource),
      clientController: new ClientController(this.$resource),
      userController: new UserController(this.$resource),
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      modalNewWallet: false,
      clientItems: [],
      Vclient: '',
      users: [],
      selectedUsers: '',
      saldoAdicionar: 0,
      saldoDescription: '',
      search: '',
      notsingleClient: false,
      isLoadingUser: false,
      headers: [
        { text: 'ID', value: 'id' },
        {
          text: 'Saldo',
          value: 'money',
        },
        { text: 'Usuário', value: 'user.name' },
        { text: 'Ações', value: 'action', sortable: false },
      ],
      walletData: [],
      showModalSaldo: false,
      command: '',
      walletId: null,
    };
  },
  methods: {
    report() {
      this.blockScreen = true;
      this.walletController
        .getAll()
        .then(res => {
          this.walletData = res;
        })
        .finally(() => (this.blockScreen = false));
    },

    abrirModalSaldo(command, walletId) {
      this.command = command;
      this.walletId = walletId;
      this.showModalSaldo = true;
    },

    async editarSaldo(data) {
      data.value = await NumberHelper.convertMoneyToInteger(data.value);

      this.command == 'Adicionar'
        ? this.adicionarSaldo(data)
        : this.retirarSaldo(data);
    },

    adicionarSaldo(data) {
      this.blockScreen = true;
      this.walletController
        .adminDeposit({
          id: this.walletId,
          value: data.value,
        })
        .then(() => {
          this.showModalSaldo = false;
          this.report();
        });
    },

    retirarSaldo(data) {
      if (
        (data.type != 'Saque' && data.type != 'Cobrança') ||
        data.value <= 0
      ) {
        data.value = '0';
        return this.$awn.alert('Preencha os campos solicitados');
      }

      if (data.type == 'Cobrança') {
        data.type = 'payment';
        if (data.idReserva <= 0) {
          data.value = '0';
          return this.$awn.alert('Id de reserva invalido');
        }
      } else {
        data.type = 'withdraw';
        data.idReserva = null;
      }

      this.blockScreen = true;
      this.walletController
        .adminWithdraw({
          id: this.walletId,
          data: data,
        })
        .then(() => {
          this.showModalSaldo = false;
          this.report();
        })
        .catch(error => {
          this.$awn.alert(error.body.error);
          this.blockScreen = false;
        });
    },

    detalhesWallet(item) {
      let routeData = this.$router.resolve({
        name: 'carteira-detail',
        params: {
          id: item.id,
        },
      });
      window.open(routeData.href, '_blank');
      localStorage.setItem('pageBack', 'carteira');
    },

    async searchClients() {
      try {
        // Clients have already been loaded or Items have already been requested
        if (this.clientItems.length > 0 || this.isLoadingClient) {
          return;
        }
        this.blockScreen = true;
        this.clientItems = await this.clientController.getAllClients();
      } catch (error) {
        return this.$awn.alert('Erro ao obter clientes');
      } finally {
        this.blockScreen = false;
      }
    },

    async searchUsersFromClient() {
      try {
        if (this.Vclient.length != 1) {
          this.notsingleClient = true;
          this.users = [];
          return;
        } else {
          this.notsingleClient = false;
          this.idHold = this.Vclient[0].id;
        }

        this.isLoadingUser = true;
        this.users = await this.userController.getUsersActiveByClientId(
          this.idHold
        );
      } catch (error) {
        return this.$awn.alert('Erro ao obter usuários');
      } finally {
        this.isLoadingUser = false;
      }
    },

    cadastrarSaldo() {
      let value = this.saldoAdicionar * 100;
      this.walletController
        .promotionDeposit({
          clients: this.Vclient,
          users: this.selectedUsers,
          value,
          description: this.saldoDescription,
        })
        .then(res => {
          this.$awn.success(res.message);
        })
        .catch(e => {
          console.log(e);
          this.$awn.alert(e.message);
        });
    },
  },
  filters: {
    formatPrice(price) {
      return NumberHelper.formatPrice(price);
    },

    formatName(nome) {
      if (!nome) return '';

      return nome
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
  },
};
</script>
<style lang="scss">
.box {
  background-color: rgb(253, 252, 252);
  width: 100%;
}

h5 {
  color: rgb(102, 102, 102);
  font-weight: 400;
}

.radios {
  margin: 5px;
}
.radios input {
  margin-right: 3px;
}
.radios label {
  margin-right: 15px;
}
.table-custom-vue {
  margin: 20px;
}
.table-custom-vue td:last-child {
  display: flex;
  justify-content: center;
}
.table-custom-vue thead tr > th,
.table-custom-vue tbody td {
  text-align: center !important;
}

.import-driver-button,
.new-driver-button {
  border: none;
  &:hover {
    background: var(--primary-color-hover);
  }
}
.card-header .filter-header {
  background: var(--secondary-color) !important;
}

.import-driver-button,
.new-driver-button {
  border: none;
  &:hover {
    color: white;
    background: var(--primary-color-hover);
  }
}
</style>
